import React, {Component} from 'react';

class RenderDocumentBody extends Component {
    render() {
        return (
            <div>
                body
            </div>
        );
    }
}

export default RenderDocumentBody;